import isEmpty from 'lodash/isEmpty'
import { getCompanyFormGroupLabelByCompanyForm } from '../create/company'

const EMPTY_PROP = '–'

export const getClientKind = (kind) => {
  switch (kind) {
    case 'private':
      return 'Privat'
    case 'company':
      return 'Firma'
    default:
      return 'Privat'
  }
}

export const getContactUserName = (contactUser) => {
  if (!contactUser.length) return EMPTY_PROP

  return contactUser.map((user) => {
    const { firstName = '', lastName = '' } = user
    const name = `${firstName} ${lastName}`.trim()

    if (!name.length) {
      return user.email || user.invitationEmail || user.originalEmail
    }

    return name
  })
}
export const getContactEmail = (contactUser) => {
  if (!contactUser.length) return EMPTY_PROP

  return contactUser.map((user) => {
    const email = `${user.email}`.trim()

    if (!email.length) {
      return user.invitationEmail || user.originalEmail
    }

    return email
  })
}

export default class ClientListModel {
  constructor(data) {
    this.id = data.id
    this.clientNumber = data.clientNumber || EMPTY_PROP
    this.name = data.name || EMPTY_PROP
    this.inviterStatus = data.inviterStatus || EMPTY_PROP
    this.inviteeStatus = data.inviteeStatus || EMPTY_PROP
    this.connectionStatus = data.connectionStatus || EMPTY_PROP
    this.email = getContactEmail(data.contactUser)
    this.companyForm = getCompanyFormGroupLabelByCompanyForm(data.companyForm) || EMPTY_PROP
    if (!isEmpty(data.companyAddress)) {
      this.street = data.companyAddress.street || EMPTY_PROP
      this.zipCode = data.companyAddress.zipCode || EMPTY_PROP
      this.city = data.companyAddress.city || EMPTY_PROP
    }
    this.clerks = data.clerks
    this.contactUser = getContactUserName(data.contactUser)
  }
}
